import { GamoraControllerTransitionMap } from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakClientStateAbort } from './states/client/abort.state.js';
import { HoruzProtocolChulakClientStateAgentStart } from './states/client/agent-start.state.js';
import { HoruzProtocolChulakClientStateAppPairing } from './states/client/app-pairing.state.js';
import { HoruzProtocolChulakClientStateAppPresentation } from './states/client/app-presentation.state.js';
import { HoruzProtocolChulakClientStateAuth } from './states/client/auth.state.js';
import { HoruzProtocolChulakClientStateDone } from './states/client/done.state.js';
import { HoruzProtocolChulakServerStateAuth } from './states/server/auth.state.js';
import { HoruzProtocolChulakServerStateClose } from './states/server/close.state.js';
import { HoruzProtocolChulakServerStateOpen } from './states/server/open.state.js';
import { HoruzProtocolChulakServiceStateAbort } from './states/service/abort.state.js';
import { HoruzProtocolChulakServiceStateAgentStart } from './states/service/agent-start.state.js';
import { HoruzProtocolChulakServiceStateAppPairing } from './states/service/app-pairing.state.js';
import { HoruzProtocolChulakServiceStateAppPresentation } from './states/service/app-presentation.state.js';
import { HoruzProtocolChulakServiceStateDone } from './states/service/done.state.js';
import { HoruzProtocolChulakServiceStateStopped } from './states/service/stopped.state.js';

/**
 * List of states on client side
 * @public
 */
export const HoruzProtocolChulakClientStateMap = {
  Auth: HoruzProtocolChulakClientStateAuth,
  AgentStart: HoruzProtocolChulakClientStateAgentStart,
  AppPairing: HoruzProtocolChulakClientStateAppPairing,
  AppPresentation: HoruzProtocolChulakClientStateAppPresentation,
  Done: HoruzProtocolChulakClientStateDone,
  Abort: HoruzProtocolChulakClientStateAbort,
} as const;

/**
 * List of allowed state transitions
 * @public
 */
export const HoruzProtocolChulakClientTransitionMap: GamoraControllerTransitionMap<
  typeof HoruzProtocolChulakClientStateMap
> = {
  Auth: ['AgentStart', 'AppPairing', 'AppPresentation', 'Abort', 'Done'],
  AgentStart: ['AppPairing', 'Abort'],
  AppPairing: ['AppPresentation', 'Abort'],
  AppPresentation: ['Done', 'Abort'],
  Abort: [],
  Done: [],
} as const;

/**
 * List of states on server side
 * @public
 */
export const HoruzProtocolChulakServerStateMap = {
  Auth: HoruzProtocolChulakServerStateAuth,
  Close: HoruzProtocolChulakServerStateClose,
  Open: HoruzProtocolChulakServerStateOpen,
} as const;

/**
 * List of allowed state transitions
 * @public
 */
export const HoruzProtocolChulakServerTransitionMap: GamoraControllerTransitionMap<
  typeof HoruzProtocolChulakServerStateMap
> = {
  Auth: ['Open', 'Close'],
  Open: ['Close'],
  Close: [],
} as const;

/**
 * List of states on server side
 * @public
 */
export const HoruzProtocolChulakServiceStateMap = {
  Done: HoruzProtocolChulakServiceStateDone,
  Stopped: HoruzProtocolChulakServiceStateStopped,
  Abort: HoruzProtocolChulakServiceStateAbort,
  AgentStart: HoruzProtocolChulakServiceStateAgentStart,
  AppPairing: HoruzProtocolChulakServiceStateAppPairing,
  AppPresentation: HoruzProtocolChulakServiceStateAppPresentation,
} as const;

/**
 * List of allowed state transitions
 * @public
 */
export const HoruzProtocolChulakServiceTransitionMap: GamoraControllerTransitionMap<
  typeof HoruzProtocolChulakServiceStateMap
> = {
  AgentStart: ['AppPairing', 'Abort', 'Stopped'],
  AppPairing: ['AppPresentation', 'Abort', 'Stopped'],
  AppPresentation: ['Done', 'Abort', 'Stopped'],
  Abort: [],
  Stopped: [],
  Done: [],
} as const;
